import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexto/AuthContext';

function Login() {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { login, isAuthenticated } = useContext(AuthContext);

    // Redirigir si ya está autenticado
    React.useEffect(() => {
        if (isAuthenticated) {
            console.log('User already authenticated, redirecting to home');
            navigate('/');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const result = await login(email, pass);
            
            if (result.success) {
                console.log('Login successful, redirecting...');
                // El redirect ocurrirá automáticamente cuando isAuthenticated cambie
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError('Error al iniciar sesión');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">
                <div>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4 mt-4">
                            <label htmlFor='email'>Usuario</label>
                            <input 
                                type="email" 
                                placeholder="Yourniny@Trotamundos.fly" 
                                id='email' 
                                value={email} 
                                onChange={e => setEmail(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        <div className="mb-4 mt-4">
                            <label htmlFor='pass'>Contraseña</label>
                            <input 
                                type="password" 
                                placeholder="El_viajero_indiscreto_🤫" 
                                value={pass} 
                                onChange={e => setPass(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        {error && <p className="text-danger">{error}</p>}
                        <button 
                            type="submit" 
                            className="my-4 btn btn-primary" 
                            style={{width:"100%"}}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Iniciando sesión...' : 'Entrar'}
                        </button>
                    </form>
                    
                    <br/>
                    <p>¿Has olvidado tu contraseña? recupera tu cuenta <a href='/recuperar'>aquí</a></p>
                </div>
            </div>
            <title>Login</title>
        </>
    );
}

export default Login;